import { render } from "./mytestmethodsview.vue?vue&type=template&id=5a66170c"
import script from "./mytestmethodsview.vue?vue&type=script&lang=js"
export * from "./mytestmethodsview.vue?vue&type=script&lang=js"

import "./mytestmethodsview.vue?vue&type=style&index=0&id=5a66170c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__